import ZEntityContainer from '@/ZForms/parsers/entities/ZEntityContainer.js';


export default window.ZForms.registerClass('container.form', class ZForm extends ZEntityContainer {
  constructor() {
    super(...arguments);
    this.drawStyle = 'column';
  }

  _updateParamsFromRaw(rawData) {
    super._updateParamsFromRaw(rawData);
    this.drawStyle = rawData.draw_style ? rawData.draw_style : this.drawStyle;
  }
});
